import { AiFillEye } from 'react-icons/ai'
import { FiLoader } from 'react-icons/fi'
import { useTranslation } from 'react-i18next'
import { isEmpty, startCase } from 'lodash'
import { BsArrowUpShort } from 'react-icons/bs'

const SubmittedFormsEmployeeTable = ({
  submitEmployeeList,
  page,
  sort,
  setSort,
  handleView,
  isLoading // ✅ new prop
}) => {
  const { t } = useTranslation()

  return (
    <div>
      <div className='p-3'>
        <div className='rounded-lg overflow-x-auto relative border'>
          <table className='dark:text-gray-400 w-full text-xs text-left text-[#6c6c6c] '>
            <thead className='dark:bg-gray-700 text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:text-gray-400'>
              <tr>
                <th scope='col' className='py-3 px-6'>
                  Sr no.
                </th>
                <th className='py-3 px-6' scope='col'>
                  {t('EMPLOYEE_ID')}
                </th>
                <th scope='col' className='px-6 py-3 '>
                  {t('EMPLOYEE_NAME')}
                </th>
                <th className='py-3 px-6' cope='col'>
                  {t('JOB_TITLE')}
                </th>
                <th scope='col' className='px-6 py-3 '>
                  {t('DEPARTMENT')}
                </th>
                <th
                  scope='col'
                  className='px-6 cursor-pointer py-3 '
                  onClick={() => {
                    const newSortType = sort.sortType === 'asc' ? 'desc' : 'asc'
                    setSort({
                      sortBy: 'Employee.email',
                      sortType: newSortType
                    })
                  }}
                >
                  <div className='flex justify-start'>
                    <span>{t('EMAIL_ID')}</span>
                    <span>
                      {sort.sortBy === 'Employee.email' && (
                        <BsArrowUpShort
                          className={`w-4 h-4 ${
                            sort.sortType === 'asc' ? '' : 'rotate-180'
                          }`}
                        />
                      )}
                    </span>
                  </div>
                </th>
                <th scope='col' className='px-6 py-3 '>
                  {t('YEAR_OF_EXPERIENCE')}
                </th>
                <th className='text-center py-3 px-6 ' scope='col'>
                  {t('O_STATUS')}
                </th>
                <th scope='col' className='px-6 text-center py-3'>
                  {t('O_ACTION')}
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-10 px-6 text-center' colSpan={9}>
                    <div className='flex items-center justify-center gap-2 text-gray-600'>
                      <FiLoader className='animate-spin w-5 h-5' />
                      <span>{t('O_LOADING') || 'Loading...'}</span>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {submitEmployeeList &&
                    submitEmployeeList?.map((item, i) => {
                      return (
                        <tr
                          key={i}
                          className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                        >
                          <th
                            scope='row'
                            className='py-4 px-6 border-r font-medium text-gray-900  dark:text-white'
                          >
                            {i + 1 + 10 * (page - 1)}
                          </th>
                          {/* <td className='border-r py-4 px-6 text-gray-900'>
                            {item?.Employee?.employeeId}
                          </td> */}
                          <td className="border-r py-4 px-4 text-gray-900">{item?.employmentStatus === "terminated" ? `${item?.Company.name.substring(0, 3)}${item.Employee._id.toString().slice(-3)}` :item?.Employee?.employeeId}</td>
                          <td className='px-6 border-r py-4 text-gray-900'>
                            {item?.Employee?.name}
                          </td>
                          <td className='text-gray-900 py-4 px-6 border-r '>
                            {item?.Job?.name}
                          </td>
                          <td className='py-4 border-r px-6 text-gray-900'>
                            {item?.Department?.name}
                          </td>
                          <td className='py-4 px-6 border-r text-gray-900'>
                            {item?.Employee?.email}
                          </td>
                          <td className='py-4 px-6 border-r text-gray-900'>
                            {item?.yearOfExperiece}
                          </td>
                          {/* <td className='py-4 px-6 border-r text-gray-900'>
                            {startCase(item?.formStatus)}
                          </td> */}
                            <td className="border-r py-4 px-4 text-gray-900">{startCase(item?.employmentStatus === "terminated" ? item?.employmentStatus : item?.formStatus)}</td>
                          <td className='px-6 border-l py-4 text-gray-900'>
                            <div className=''>
                              <ul className='justify-center flex '>
                                <li
                                  onClick={() => handleView(item)}
                                  className='hover:bg-white px-2 py-2 hover:text-LightBlue'
                                >
                                  <a title='View employee list'>
                                    {' '}
                                    <AiFillEye className='h-5 cursor-pointer w-5 text-slate-600' />{' '}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  {isEmpty(submitEmployeeList) ? (
                    <tr className='bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700'>
                      <td className='py-4 px-6 border-r' colSpan={9}>
                        {t('O_NO_RECORD_FOUND')}
                      </td>
                    </tr>
                  ) : null}
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default SubmittedFormsEmployeeTable